import axios from 'axios'
import lodash from 'lodash'
import EventBus from '@/controllers/EventBus'

var IS_HTTPS = false
var BASE_URL
if (process.env.NODE_ENV === 'production') {
  IS_HTTPS = true
  BASE_URL = '//bosshogcookoff.com/october/'
} else {
  // IS_HTTPS = false
  // BASE_URL = '//localhost:8080/october_bosshog/'
  IS_HTTPS = true
  BASE_URL = '//bosshogcookoff.com/october/'
}

export default {

  forceSecure: IS_HTTPS, // true = autodetect, false = always secured
  baseUrl: BASE_URL,
  getProtocol () {
    var protocol = window.location.protocol
    if (!protocol || protocol.length <= 0) {
      protocol = 'http:'
    }
    if (this.forceSecure) {
      protocol = 'https:'
    }
    return protocol
  },

  // callback format: (result, data, error)
  post (path, data, noJson) {
    // context.$http.interceptors.push(function (request, next) {
    //   request.headers.set('Access-Control-Allow-Origin', '*')
    //   next()
    // })

    lodash.merge(data, {
      client_id: 1,
      client_secret: 'n4FdG7FaF14ka2id8WySAwHTtgdAGwBQTqovmeW0'
    })

    return new Promise((resolve, reject) => {
      axios.post(this.getProtocol() + this.baseUrl + path, data)
      .then(response => {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 })
          return
        }

        if (noJson) {
          resolve(response.data)
          return
        }

        // validate if proper JSON
        if (typeof response.data !== 'object') {
          console.log(response)
          reject({ error: 'Invalid JSON data', code: 400 })
          return
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code })
          return
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data)
      })
      .catch(error => {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 })
          return
        }

        // console.log(error)
        if (!error.response ||
          !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 })
          return
        }

        // validate if proper JSON
        if (typeof error.response.data !== 'object') {
          console.error(error.response)
          reject({ error: 'Invalid JSON error', code: 400 })
          return
        }

        if (error.response.data.code === 401) {
          EventBus.$emit('unauthenticated')
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data)
      })
    })

    // context.$http.post(LOGIN_URL, creds, {
    //   headers: {
    //     // 'Access-Control-Allow-Methods': '*'
    //   }
    // }).then(data => {
    //   console.log(data)
    //   localStorage.setItem('id_token', data.id_token)
    //   localStorage.setItem('access_token', data.access_token)
    //
    //   this.user.authenticated = true
    //
    //   // Redirect to a specified route
    //   if (redirect) {
    //     console.log('redirected')
    //     // router.go(redirect)
    //   }
    // }, err => {
    //   console.log('error login')
    //   console.log(err)
    //   context.error = err
    // })
  },
  get (path, params, noJson) {
    noJson = noJson !== undefined ? noJson : false
    return new Promise((resolve, reject) => {
      axios.get(this.getProtocol() + this.baseUrl + path,
        { params: params },
        {
          headers: {
            'HTTP_ORIGIN': 'http://localhost:8080'
          }
        }
      )
      .then(response => {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 })
          return
        }

        if (noJson) {
          resolve(response.data)
          return
        }

        // validate if proper JSON
        if (typeof response.data !== 'object') {
          reject({ error: 'Invalid JSON data', code: 400 })
          return
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code })
          return
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data)
      })
      .catch(error => {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 })
          return
        }

        // console.log(error)
        if (!error.response ||
          !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 })
          return
        }

        // validate if proper JSON
        if (typeof error.response.data !== 'object') {
          reject({ error: 'Invalid JSON error', code: 400 })
          return
        }

        if (error.response.data.code === 401) {
          EventBus.$emit('unauthenticated')
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/index.js